<template>
  <b-modal
    title="New Question"
    v-model="showModal"
    ok-title="Create Question"
    @ok.prevent="handleSubmit"
    @cancel.prevent="cancel"
  >
    <b-form-group
      label="How would you like to get started?"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-radio-group
        id="radio-question-base"
        v-model="questionBaseSelected"
        :options="questionBaseOptions"
        :aria-describedby="ariaDescribedby"
        button-variant="outline-primary"
        name="radio-question-base"
        class="w-100 two-toggle-equal-width"
        buttons
      ></b-form-radio-group>
    </b-form-group>
    <div v-if="isUsingTemplate">
      <b-form-input
        type="text"
        placeholder="Enter search text"
        v-model="questionSearchFilter"
      ></b-form-input>
      <b-table
        v-if="questionTemplates && questionTemplates.length"
        striped
        responsive
        hover
        :items="questionTemplates"
        :fields="questionFields"
        :filter="questionSearchFilter"
        class="question-templates-table"
      >
        <template v-slot:cell(question_checkbox)="data">
          <b-form-checkbox v-model="data.item.isChecked"></b-form-checkbox>
        </template>
      </b-table>
    </div>
    <div v-else>
      <form @submit.prevent="handleNewQuestionSubmit">
        <b-form-group
          id="questionTextGroup"
          label="Question Text"
          label-for="questionText">
            <b-form-textarea
              id="questionText"
              :state="errors.length == 0 ? null : validateQuestion()"
              placeholder="Enter your question here..."
              v-model.trim="question.text"
              maxLength="400"
              rows="3"
              max-rows="6"
            >
            {{question.text}}
            </b-form-textarea>
            <p class="body-p">{{question.text.length}} / 400 Max Characters </p>
        </b-form-group>
        <b-form-group
          id="questionTypeGroup"
          label="Question Type"
          label-for="questionType">
            <b-form-select id="questionType" v-model="question.type">
              <b-form-select-option value="Multiple Choice (Graded)">Multiple Choice (Graded)</b-form-select-option>
              <b-form-select-option value="Short Answer">Short Answer</b-form-select-option>
            </b-form-select>
        </b-form-group>
        <div v-if="this.isMultiQuestion">
          <b-row
            class="text-left mb-2"
            v-for="answer in question.answerOptions"
            v-bind:key="answer.answerIndex">
            <b-col cols="1" class="text-center font-weight-bold">{{answer.answerIndex}}</b-col>
            <b-col cols="11">
              <b-form-input
                v-model.trim="answer.answerText"
                size="sm"
                maxlength="250"
                :state="errors.length == 0 ? null : validateAnswer(answer.answerText)"
                :placeholder="'Enter an answer for ' +answer.answerIndex">
                {{answer.answerText}}
              </b-form-input>
            </b-col>
            <b-col cols="2"></b-col>
          </b-row>
        </div>
      </form>
    </div>
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
    <!-- <EditQuestionForm
      ref="edit-question-form"
      :question="question"
      :mode="mode"
      :surveyId="surveyId"
      @submit="submit"
      @reset="cancel">
    </EditQuestionForm> -->
  </b-modal>
</template>

<script>
import axios from "axios";

// import EditQuestionForm from "@/form-components/EditQuestionForm.vue";

export default {
  name: 'CreateQuestionModal',
  props: {
    // questionId: { type: String, default: null },
    survey: { type: Object, required: true },
    // surveyId: { type: String, required: true }
    // mode: { type: String, default: 'Edit' },
    // question: { type: Object, default: null },
  },
  components: {
    // EditQuestionForm
  },
  data() {
    return {
      showModal: false,
      errors: [],
      dataLoaded: true,
      // mode: null,
      questionLength: 0,
      waiters: {
        loading: false,
        sending: false
      },
      question: {
        questionId: "",
        text: "",
        sortOrder: 0,
        type: "Multiple Choice (Graded)",
        required: true,
        answerOptions: []
      },
      questionBaseOptions: [
        { text: 'Use Question Template', value: 'template' },
        { text: 'Create New', value: 'new' }
      ],
      questionBaseSelected: 'template',
      questionTemplates: [],
      questionFields: [
        { key: "question_checkbox", label: "" },
        { key: "text", label: "Question", sortable: true }
      ],
      questionSearchFilter: "",
      addedQuestions: []
    }
  },
  computed: {
    isMultiQuestion() {
      return this.question ? 
        this.question.type === "Multiple Choice (Graded)" :
        true;
    },
    isUsingTemplate() {
      return this.questionBaseSelected === 'template';
    }
  },
  watch: {
    isMultiQuestion(isMulti) {
      this.resetAnswerOptions();
    },
    // questionId(id) {
    //   if(id.length > 0) {
    //     this.setupEditQuestion();
    //   }
    // }
  },
  mounted() {
    this.refreshQuestionTemplates(this.removeQuestionsAlreadyInList);
  },
  methods: {
    show() {
      this.showModal = true;
      // if (this.questionId) {
      //   this.setupEditQuestion();
      // } else {
      //   this.setupNewQuestion();
      // }
      this.setupNewQuestion();
      this.refreshQuestionTemplates(this.removeQuestionsAlreadyInList);
    },
    hide() {
      this.showModal = false;
    },
    // submit() {
    //   this.$emit('submit');
    // },
    cancel() {
      this.reset();
      this.hide();
    },
    reset() {
      this.resetForm();
    },
    resetForm() {
      this.errors=[],
      // this.mode=null,
      this.question={
        questionId: "",
        text: "",
        sortOrder: 0,
        type: "Multiple Choice (Graded)",
        required: true,
        answerOptions: []
      }
    },
    setupNewQuestion() {
      // this.mode = "Create";
      if (this.survey.surveyId) {
        this.question.surveyId = this.survey.surveyId;
      }
      this.createNewAnswerOptions();
      this.$emit('loaded');
    },
    // setupEditQuestion() {
    //   this.mode = "Edit";
    //   this.waiters.loading = true;
    //   axios
    //     .get(`${this.$api_url}/questions/${this.questionId}`,
    //       this.getReqConfig()
    //     )
    //     .then(response => {
    //       this.question = response.data;
    //       if (this.question.answerOptions.length === 0) {
    //         this.createNewAnswerOptions();
    //       }
    //       this.question.answerOptions.sort((a, b) => a.answerIndex > b.answerIndex ? 1 : -1);
    //     })
    //     .catch(err => {
    //       this.errors.push(err);
    //       this.dataLoaded = false;
    //     })
    //     .finally(() => {
    //       this.waiters.loading = false;
    //       this.$emit('loaded');
    //     });
    // },
    resetAnswerOptions() {
      this.question.answerOptions.forEach(option => {
        option.answerText = "";
        option.commentRequired = false;
      });
      
    },
    createNewAnswerOptions() {
      this.question.answerOptions = [
        {
          answerIndex: "A",
          answerText: "",
          answerScore: 4,
          commentRequired: false
        },
        {
          answerIndex: "B",
          answerText: "",
          answerScore: 3,
          commentRequired: false
        },
        {
          answerIndex: "C",
          answerText: "",
          answerScore: 2,
          commentRequired: true
        },
        {
          answerIndex: "D",
          answerText: "",
          answerScore: 1,
          commentRequired: true
        },
        {
          answerIndex: "F",
          answerText: "",
          answerScore: 0,
          commentRequired: true
        },
        {
          answerIndex: "NA",
          answerText: "",
          answerScore: -1,
          commentRequired: false
        }
      ];
    },
    refreshQuestionTemplates(next) {
      axios
        .get(`${this.$api_url}/question-templates`, this.getReqConfig())
        .then(response => {
          this.questionTemplates = this.addIsCheckedToQuestionList(
            this.sortQuestionsList(response.data)
          );
        })
        // eslint-disable-next-line
        .then(r => {
          next();
        })
        .catch(err => {
          this.errors.push(err);
        });
    },
    sortQuestionsList(questions) {
      return questions.sort(function(a, b) {
        return a.text > b.text ? 1 : -1;
      });
    },
    removeQuestionsAlreadyInList
    : async function() {
      for (let q of this.survey.questions) {
        let idx = this.questionTemplates.findIndex(
          t => t.text === q.text
        );
        if (idx > -1) {
          this.questionTemplates.splice(idx, 1);
        }
      }
    },
    addIsCheckedToQuestionList(questionList) {
      for (let q of questionList) {
        q.isChecked = false;
      }
      return questionList;
    },
    validateForm() {
      let formIsValid = true;
      if (!this.validateQuestion()) {
        formIsValid = false;
        this.errors.push({
          message: "Please enter a question 5 or more characters in length."
        });
      }
      if (this.isMultiQuestion) {
        for (let a of this.question.answerOptions) {
          if (!this.validateAnswer(a.answerText)) {
            formIsValid = false;
            this.errors.push({
              message: `Answer '${a.answerIndex}' must be 2 or more characters in length.`
            });
          }
        }
      }
      return formIsValid;
    },
    validateQuestion() {
      this.questionLength = this.question.text.length;
      return this.question.text.length >= 5 && this.question.text.length <= 450;
    },
    validateAnswer(text) {
      return text.length >= 2;
    },
    handleSubmit() {
      if (this.isUsingTemplate) {
        this.addQuestionsFromTemplates();
      } else {
        this.handleNewQuestionSubmit();
      }
    },
    addQuestionsFromTemplates() {      
      let questionSortOrder = this.survey.questions.length;
      for (let q of this.questionTemplates) {
        if (q.isChecked) {
          this.waiters.sending = true;

          // delete q.isChecked;
          // let max = Math.max.apply(Math, this.survey.questions.map(q => q.sortOrder));
          // q.sortOrder = (isFinite(max) ? max : -1) + 1;

          let newQuestion = {...q};
          newQuestion.questionId = this.$helpers.generateUUID();
          newQuestion.surveyId = this.survey.surveyId;

          newQuestion.sortOrder = questionSortOrder;
          questionSortOrder++;

          delete newQuestion.isChecked;

          newQuestion.answerOptions.forEach(ao => {
            ao.answerOptionId = this.$helpers.generateUUID();
            ao.questionId = newQuestion.questionId;
          });
          
          this.addedQuestions.push(newQuestion);
          // this.sortSurveyQuestions();

          axios
          .put(`${this.$api_url}/question/add`, newQuestion, this.getReqConfig())
          .then(() => {
            const checkedQuestionsLength = this.questionTemplates.filter(q => q.isChecked).length;
            if (checkedQuestionsLength === this.addedQuestions.length) {
              this.questionTemplates = this.questionTemplates.filter(q => !q.isChecked);

              // const surveyLength = this.survey.questions.length;
              // this.addedQuestions.forEach((question, index) => {
              //   question.sortOrder = surveyLength + index;
              // });

              this.$emit('submitTemplates',this.addedQuestions);
              this.reset();
              this.hide();
            }
          })
          .catch(err => {
            if (err.response && err.response.data) {
              this.errors.push(...err.response.data.map(e => ({message: e})));
            } else {
              this.errors.push(err);
            }
            this.waiters.sending = false;
          });
          
        }
      }
      this.removeQuestionsAlreadyInList();
    },
    handleNewQuestionSubmit() {
      this.errors = [];
      if (this.validateForm()) {
        if (!this.question.questionId) {
          this.question.questionId = this.$helpers.generateUUID();
        }
        this.question.answerOptions.forEach(ao => {
          if (!ao.answerOptionId) {
            ao.answerOptionId = this.$helpers.generateUUID();
          }
        });
        this.question.sortOrder = this.survey.questions.length;

        this.waiters.sending = true;
        axios
          .put(`${this.$api_url}/question/add`, this.question, this.getReqConfig())
          .then(() => {
            // if (this.mode != "Edit") {
            //   this.$router.push({
            //     name: "Edit Question Template",
            //     params: { id: this.question.questionId }
            //   });
            // }
            // this.$router.go();
            this.$emit('submit', this.question);
            this.reset();
            this.hide();
          })
          .catch(err => {
            if (err.response && err.response.data) {
              this.errors.push(...err.response.data.map(e => ({message: e})));
            } else {
              this.errors.push(err);
            }
            this.waiters.sending = false;
          });

      } else {
        // let message =
        //   "Some entries are invalid. Please correct these and resubmit.";
        // this.errors.push({ message });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .question-templates-table {
    // width: auto;
    // height: auto;
    max-height: 50vh;
    overflow-y: auto;
  }
  /deep/ .btn-outline-primary {
    padding: 1.039em 1em !important;
    color: #529ce3;
    color: var(--ct-blue);
    border-color: #529ce3;
    border-color: var(--ct-blue);

    &:not(:disabled):not(.disabled).active,
    &:not(:disabled):not(.disabled):hover {
      color: #fff;
      background-color: #529ce3 !important;
      background-color: var(--ct-blue) !important;
      border-color: #529ce3;
      border-color: var(--ct-blue);
    }
  }
  /deep/ .two-toggle-equal-width > label {
    width: 50%;
  }
</style>